import { get, post } from './api';

export const login = values => post('/auth/login', values);
export const setPassword = values => post('/auth/setPassword', values);
export const getUserInfo = () => get('/auth/me');
